import { render, staticRenderFns } from "./CommandManagement.vue?vue&type=template&id=44808bdf&scoped=true"
import script from "./CommandManagement.vue?vue&type=script&lang=js"
export * from "./CommandManagement.vue?vue&type=script&lang=js"
import style0 from "./CommandManagement.vue?vue&type=style&index=0&id=44808bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44808bdf",
  null
  
)

export default component.exports